import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

/**
 * Destino de los redirects de `RequireRole` y `RequireSuperAdmin`.
 *
 * Vive aquí, junto a los guards que la usan, y no dentro de una feature: la
 * ruta la registra `features/superadmin/routes.jsx` (TASK-22) pero cualquier
 * guard puede llevar aquí. Hasta TASK-22 la ruta no existía en ningún
 * `routes.js`, así que un acceso denegado dejaba la pantalla en blanco.
 */
function UnauthorizedPage() {
  const { isAuthenticated, logout } = useAuth();

  return (
    <Container className="py-5 text-center" style={{ maxWidth: 560 }}>
      <h1 className="h4 mb-3">Acceso no autorizado</h1>
      <p className="text-muted">
        Tu cuenta no tiene permisos para ver esta página. Si crees que es un
        error, pide a un administrador que revise tu rol.
      </p>
      <div className="d-flex gap-2 justify-content-center flex-wrap mt-4">
        <Button as={Link} to="/" variant="primary" style={{ minHeight: 44 }}>
          Volver al inicio
        </Button>
        {isAuthenticated && (
          <Button variant="outline-secondary" onClick={logout} style={{ minHeight: 44 }}>
            Cerrar sesión
          </Button>
        )}
      </div>
    </Container>
  );
}

export { UnauthorizedPage };
